export default class SharePageModal {
    constructor($el) {
        this.$el = $el;
        this.$toggle = document.querySelector(`[data-share-page-modal-toggle="${this.$el.dataset.sharePageModal}"]`);

        if ( ! this.$toggle) {
            return;
        }

        this.$inner = this.$el.querySelector('[data-share-page-modal-inner]');
        this.$close = this.$el.querySelector('[data-share-page-modal-close]');
        this.$html = document.querySelector('html');

        this.closeModal = this.closeModal.bind(this);
        this.openModal = this.openModal.bind(this);
        this.handleModalClick = this.handleModalClick.bind(this);

        this.$close.addEventListener('click', (e) => {
            e.preventDefault();
            this.closeModal();
        });

        this.$el.addEventListener('animationend', (e) => {
            if (e.animationName === 'modal-out') {
                this.$el.classList.remove('animate');
            }
        });

        this.$el.addEventListener('click', this.handleModalClick);

        this.$toggle.addEventListener('click', (e) => {
            e.preventDefault();
            this.openModal();
        })
    }

    closeModal() {
        this.$el.classList.add('hidden');
        this.$html.classList.remove('no-scroll');
    }

    openModal() {
        this.$el.classList.add('animate');
        this.$el.classList.remove('hidden');
        this.$html.classList.add('no-scroll');
    }

    handleModalClick(e) {
        if (this.$inner.contains(e.target)) {
            return;
        }

        this.closeModal();
    }
}
